import { ThemeOptions } from "@mui/material";

export default <ThemeOptions["components"]["MuiDialogActions"]>{
  styleOverrides: {
    root: {
      padding: "8px 16px 12px",
    },
  },
};
